module.exports = __webpack_public_path__ + "media/images/proof_links/colored/discordapp-0f8f9c2fd5b99c8ee8b85b8d64fb1032.svg";